module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/alipay-logo-88145b9863b0606500f26cf576560759.png";